//
// Original collection by Kjetil Midtgarden Golid
// https://github.com/kgolid/chromotome
// https://kgolid.github.io/chromotome-site/
//
export default [
  {
    name: 'mayo1',
    colors: ['#ea510e', '#ffd203', '#0255a3', '#039177', '#111111'],
    stroke: '#111111',
    background: '#fff',
    type: 'mayo',
  },
  {
    name: 'mayo2',
    colors: ['#ea663f', '#f9cc27', '#84afd7', '#7ca994', '#f1bbc9', '#242424'],
    stroke: '#2a2a2a',
    background: '#f5f6f1',
    type: 'mayo',
  },
  {
    name: 'mayo3',
    colors: ['#ea5b19', '#f8c9b9', '#137661', '#2a2a2a'],
    stroke: '#2a2a2a',
    background: '#f5f4f0',
    type: 'mayo',
  },
];
